import { Box, Flex } from "@nestoca/ui";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

import styles from "./menu-trigger-button.module.scss";

interface MenuTriggerButtonProps {
  ddActionName: string;
  children: React.ReactNode;
  isMenuOpen?: boolean;
}

export const MenuTriggerButton = ({
  ddActionName,
  children,
  isMenuOpen,
}: MenuTriggerButtonProps) => {
  return (
    <Flex className={styles.button} gap={4}>
      <Box className={styles["button-name"]} data-dd-action-name={ddActionName}>
        {children}
      </Box>
      {isMenuOpen ? (
        <BsChevronUp
          size={17}
          color={"var(--color-brand)"}
          className={styles["button-icon"]}
        />
      ) : (
        <BsChevronDown
          size={17}
          color={"var(--color-brand)"}
          className={styles["button-icon"]}
        />
      )}
    </Flex>
  );
};
